import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StudentdialogdataService {

  constructor() { }
  private formData$ = new BehaviorSubject<any | null>(null);

  setFormData(data: any) {
    this.formData$.next(data);
  }

  getFormData() {
    return this.formData$.asObservable();
  }

  clearFormData() {
    this.formData$.next(null);
  }
}
